<div class="d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center gap-4">

    <!-- hamburger for mobile: toggles mobile menu in panel layout -->
    <button class="btn btn-ghost d-lg-none p-2 me-2" (click)="onToggleMobileMenu()" aria-label="Toggle menu">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 12H21" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3 6H21" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3 18H21" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <div class="form-switch-toggle d-flex" *ngIf="showToggler">
      <label class="switch-toggle mb-0">
        <input type="checkbox" [checked]="sidebarOpen" (change)="onToggleSidebar()">
        <span class="slider round"></span>
      </label>
    </div>

    <!-- search input -->
    <!-- <div class="search-container search-table" *ngIf="showSearch && authService.isInRole('Founder')">
      <span class="w-100 icon-serch">
        <svg-icon class="svg-icon" [src]="'/assets/Icons/new/search-normal.svg'"></svg-icon>
        <input class="form-control search-input" type="text" pInputText [(ngModel)]="searchText"
          placeholder="Search among all courses" (ngModelChange)="search()" />
      </span>
    </div> -->

  </div>

  <div class="d-flex align-items-center gap-3">
    <!-- Language Selector -->
    <!-- <app-language-selector></app-language-selector> -->

    <!-- <div class="notifications">
      <button class="notif-btn btn btn-light p-2">
        <div class="icon">
          <img src="/assets/Icons/new/notification.svg" alt="">
          <i class="badge-icon"></i>
        </div>
      </button>
    </div> -->

    <div class="profile">
      <button class="btn border-0 p-0 d-flex align-items-center gap-2" (click)="op.toggle($event)">
        <div class="avatar avatar-md">
          <img src="/assets/Icons/avatar.png" *ngIf="!authService.currentUserValue?.profileImageUrl">
          <img [src]="fileServerUrl + authService.currentUserValue?.profileImageUrl"
            *ngIf="authService.currentUserValue?.profileImageUrl">
        </div>
        {{authService.currentUserValue?.fullName}}
        <img src="/assets/Icons/new/angle-down.svg" alt="">
      </button>


      <p-overlayPanel #op styleClass="custom-overlay-panel">
        <ul class="m-0 p-0 profile-list">
          <li class="item mb-2" *ngIf="!authService.isAdminOrOperator && !authService.isTenantAdminOrOperator">
            <a [routerLink]="['/panel/founder/profile']">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="var(--primary)"
                class="me-1">
                <path
                  d="M22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 14.9 3.25 17.51 5.23 19.34C5.23 19.35 5.23 19.35 5.22 19.36C5.32 19.46 5.44 19.54 5.54 19.63C5.6 19.68 5.65 19.73 5.71 19.77C5.89 19.92 6.09 20.06 6.28 20.2C6.35 20.25 6.41 20.29 6.48 20.34C6.67 20.47 6.87 20.59 7.08 20.7C7.15 20.74 7.23 20.79 7.3 20.83C7.5 20.94 7.71 21.04 7.93 21.13C8.01 21.17 8.09 21.21 8.17 21.24C8.39 21.33 8.61 21.41 8.83 21.48C8.91 21.51 8.99 21.54 9.07 21.56C9.31 21.63 9.55 21.69 9.79 21.75C9.86 21.77 9.93 21.79 10.01 21.8C10.29 21.86 10.57 21.9 10.86 21.93C10.9 21.93 10.94 21.94 10.98 21.95C11.32 21.98 11.66 22 12 22C12.34 22 12.68 21.98 13.01 21.95C13.05 21.95 13.09 21.94 13.13 21.93C13.42 21.9 13.7 21.86 13.98 21.8C14.05 21.79 14.12 21.76 14.2 21.75C14.44 21.69 14.69 21.64 14.92 21.56C15 21.53 15.08 21.5 15.16 21.48C15.38 21.4 15.61 21.33 15.82 21.24C15.9 21.21 15.98 21.17 16.06 21.13C16.27 21.04 16.48 20.94 16.69 20.83C16.77 20.79 16.84 20.74 16.91 20.7C17.11 20.58 17.31 20.47 17.51 20.34C17.58 20.3 17.64 20.25 17.71 20.2C17.91 20.06 18.1 19.92 18.28 19.77C18.34 19.72 18.39 19.67 18.45 19.63C18.56 19.54 18.67 19.45 18.77 19.36C18.77 19.35 18.77 19.35 18.76 19.34C20.75 17.51 22 14.9 22 12ZM16.94 16.97C14.23 15.15 9.79 15.15 7.06 16.97C6.62 17.26 6.26 17.6 5.96 17.97C4.44 16.43 3.5 14.32 3.5 12C3.5 7.31 7.31 3.5 12 3.5C16.69 3.5 20.5 7.31 20.5 12C20.5 14.32 19.56 16.43 18.04 17.97C17.75 17.6 17.38 17.26 16.94 16.97Z" />
                <path
                  d="M12 6.92993C9.93 6.92993 8.25 8.60993 8.25 10.6799C8.25 12.7099 9.84 14.3599 11.95 14.4199C11.98 14.4199 12.02 14.4199 12.04 14.4199C12.06 14.4199 12.09 14.4199 12.11 14.4199C12.12 14.4199 12.13 14.4199 12.13 14.4199C14.15 14.3499 15.74 12.7099 15.75 10.6799C15.75 8.60993 14.07 6.92993 12 6.92993Z" />
              </svg>
              My Profile
            </a>
          </li>
          <li class="item mb-2">
            <a
              [routerLink]="[!authService.isAdminOrOperator && !authService.isTenantAdminOrOperator?'/panel/founder/change-password':'/panel/change-password']">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="me-1">
                <path
                  d="M19.7897 14.9298C17.7297 16.9798 14.7797 17.6098 12.1897 16.7998L7.47966 21.4998C7.13966 21.8498 6.46966 22.0598 5.98966 21.9898L3.80966 21.6898C3.08966 21.5898 2.41966 20.9098 2.30966 20.1898L2.00966 18.0098C1.93966 17.5298 2.16966 16.8598 2.49966 16.5198L7.19966 11.8198C6.39966 9.21982 7.01966 6.26982 9.07966 4.21982C12.0297 1.26982 16.8197 1.26982 19.7797 4.21982C22.7397 7.16982 22.7397 11.9798 19.7897 14.9298Z"
                  stroke="var(--primary)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round"></path>
                <path d="M6.88965 17.4902L9.18965 19.7902" stroke="var(--primary)" stroke-width="1.5"
                  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                <path
                  d="M14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11Z"
                  stroke="var(--primary)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>

              Change Password
            </a>
          </li>
          <li class="item">
            <a routerLink="." (click)="logout()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="var(--primary)" xmlns="http://www.w3.org/2000/svg"
                class="me-1">
                <path
                  d="M16.8 2H14.2C11 2 9 4 9 7.2V11.25H15.25C15.66 11.25 16 11.59 16 12C16 12.41 15.66 12.75 15.25 12.75H9V16.8C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2Z"
                  fill="var(--primary)" />
                <path
                  d="M4.56043 11.25L6.63043 9.17997C6.78043 9.02997 6.85043 8.83997 6.85043 8.64997C6.85043 8.45997 6.78043 8.25997 6.63043 8.11997C6.34043 7.82997 5.86043 7.82997 5.57043 8.11997L2.22043 11.47C1.93043 11.76 1.93043 12.24 2.22043 12.53L5.57043 15.88C5.86043 16.17 6.34043 16.17 6.63043 15.88C6.92043 15.59 6.92043 15.11 6.63043 14.82L4.56043 12.75H9.00043V11.25H4.56043Z"
                  fill="var(--primary)" />
              </svg>
              Logout
            </a>
          </li>
        </ul>
      </p-overlayPanel>

    </div>
  </div>

</div>